import React from 'react';

import PropTypes from 'prop-types';
import FaCheckMark from 'react-icons/lib/fa/check';
import FaSortAsc from 'react-icons/lib/fa/sort-asc';
import FaSortDesc from 'react-icons/lib/fa/sort-desc';

import styles from './DropdownArrow.scss';

function DropdownArrow(props) {
    const {
        className = '',
        isOpen = false,
        checkmark = false,
    } = props;

    const arrowClassName = isOpen
        ? `${styles.dropdownArrowUp} ${className}`
        : `${styles.dropdownArrowDown} ${className}`;

    return isOpen
        ? <FaSortAsc className={arrowClassName} />
        : (
            <div>
                {checkmark && <FaCheckMark className={styles.checkmark} />}
                <FaSortDesc className={arrowClassName} />
            </div>
        );
}

DropdownArrow.propTypes = {
    checkmark: PropTypes.bool,
    className: PropTypes.string,
    isOpen: PropTypes.bool,
};

export default DropdownArrow;
